// Author panyurou
// Date 2023-02-23 16:02:35

class SithMesCustomer {
constructor({
        id = null,
        name = '',
        dutyParagraph = '',
        telephone = '',
        fullAddress = '',
        remark = ''}
= {}) {
    this.id = id;
    this.name = name;
    this.dutyParagraph = dutyParagraph;
    this.telephone = telephone;
    this.fullAddress = fullAddress;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesCustomer();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.customer.sithMesCustomer.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'name',
        label: 'label.sith.customer.sithMesCustomer.grid.name',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'dutyParagraph',
        label: 'label.sith.customer.sithMesCustomer.grid.dutyParagraph',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'telephone',
        label: 'label.sith.customer.sithMesCustomer.grid.telephone',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'fullAddress',
        label: 'label.sith.customer.sithMesCustomer.grid.fullAddress',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.customer.sithMesCustomer.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    nameFilter : '',
    dutyParagraphFilter : '',
    telephoneFilter : '',
    fullAddressFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'nameFilter',
        label: 'label.sith.customer.sithMesCustomer.filter.name',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'dutyParagraphFilter',
        label: 'label.sith.customer.sithMesCustomer.filter.dutyParagraph',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'telephoneFilter',
        label: 'label.sith.customer.sithMesCustomer.filter.telephone',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fullAddressFilter',
        label: 'label.sith.customer.sithMesCustomer.filter.fullAddress',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'name',
        label: 'label.sith.customer.sithMesCustomer.entity.name',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
            ,required: true
                }
        },
        {
        key: 'dutyParagraph',
        label: 'label.sith.customer.sithMesCustomer.entity.dutyParagraph',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'telephone',
        label: 'label.sith.customer.sithMesCustomer.entity.telephone',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'fullAddress',
        label: 'label.sith.customer.sithMesCustomer.entity.fullAddress',
        sortable: true,
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.customer.sithMesCustomer.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesCustomer, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
